<app-banner></app-banner>

<section class="main-section white-bg">
  <div class="width-container">
    <h2 id="generic-error-header" tabindex="-1" class="no-outline" [innerHtml]="'ERROR.GENERIC_ERROR.HEAD' | translate"></h2>
    <p [innerHtml]="'ERROR.GENERIC_ERROR.DESC' | translate"></p>
    <!-- <button class="btn" [innerHtml]="'ERROR.GENERIC_ERROR.CTA_BTN' | translate" (click)="onBack()"></button> -->
  </div>
</section>
